import script from "./vxeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./vxeTable.vue?vue&type=script&setup=true&lang=js"

import "./vxeTable.vue?vue&type=style&index=0&id=487d65e3&scoped=true&lang=scss"
import "./vxeTable.vue?vue&type=style&index=1&id=487d65e3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487d65e3"]])

export default __exports__